import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

import sys from '@/sys'
import { EventTimeline, EventType, MeetingRmodel, TimelineEventRmodel } from '@/app.context/workspace/Event'
import { computed } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'EventsComponent',
  props: {
    events: {}
  },
  setup(__props: any) {


const props = __props

//const eve

const timepoints = computed(() => EventTimeline(props.events))

function eventTypeIcon(t: EventType): string {

    if (t == "A") return "bi-people-fill"
    if (t == "G") return "bi-chat-dots"
    if (t == "P") return "bi-calendar-event"

    return ""
}

function timelineIcon(i: TimelineEventRmodel) {

    if (i.events.length == 0) sys.warn('Wrong timeline item')

    else if (i.isSimple()) {

        return eventTypeIcon(i.events[0].type())
    }
    else return "bi-three-dots-vertical"
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timepoints.value, (t) => {
      return (_openBlock(), _createElementBlock("div", {
        key: t.timepointAsString()
      }, [
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(t.timepointAsString()) + " ", 1),
          _createElementVNode("i", {
            class: _normalizeClass(["bi", timelineIcon(t)])
          }, null, 2),
          (t.isSimple())
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(t.title().title) + " ", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.title().groups, (g) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: g.uid.toString()
                  }, "@@" + _toDisplayString(g.name), 1))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.title().persons, (p) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: p.nid.toString()
                  }, "@" + _toDisplayString(p.name), 1))
                }), 128)),
                (t.title().estimation > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("(" + _toDisplayString(t.title().estimation) + "min)", 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (!t.isSimple())
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(t.events, (e, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, [
                _createTextVNode(" • "),
                _createElementVNode("i", {
                  class: _normalizeClass(["bi", eventTypeIcon(e.type())])
                }, null, 2),
                _createTextVNode(),
                _createElementVNode("span", null, _toDisplayString(e.title), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(e.groups, (g) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: g.uid.toString()
                  }, "@@" + _toDisplayString(g.name), 1))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(e.persons, (p) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: p.nid.toString()
                  }, "@" + _toDisplayString(p.name), 1))
                }), 128)),
                (e.estimation > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(e.estimation) + "min", 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})